import useAuth from "../../routes/login/AuthContext";
import {RenameUnitType, UpdateInSameRoomUnitType, UpdateSizeUnitType} from "../../services/NetworkApi";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";

export const useUpdateUnit = (l2Id: number, l3Id: number) => {
  const { getAuthToken } = useAuth();
  const { updateUnitTypeValues } = useNetworkContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const handleRename = async (unitTypeName: string) => {
    await RenameUnitType(
      selectedNetworkId,
      l2Id,
      l3Id,
      { unitTypeName },
      await getAuthToken()
    );
    return updateUnitTypeValues(selectedNetworkId, l2Id, l3Id, {
      name: unitTypeName,
    });
  };

  const handleSizeUpdate = async (unitSize: number) => {
    await UpdateSizeUnitType(
      selectedNetworkId,
      l2Id,
      l3Id,
      { unitSize },
      await getAuthToken()
    );
    return updateUnitTypeValues(selectedNetworkId, l2Id, l3Id, {
      size: Number(unitSize - 1),
    });
  };

  const handleInSameRoomUpdate = async (inSameRoomEnabled: boolean) => {
    await UpdateInSameRoomUnitType(
        selectedNetworkId,
        l2Id,
        l3Id,
        { inSameRoom: inSameRoomEnabled },
        await getAuthToken()
    );
    return updateUnitTypeValues(selectedNetworkId, l2Id, l3Id, {
      inSameRoomEnabled: inSameRoomEnabled
    });
  };

  return { handleRename, handleSizeUpdate, handleInSameRoomUpdate };
};
